/**
 * Search Cache Integration
 * Integrates caching with Shopify predictive search
 *
 * This script intercepts search requests and caches results to reduce API calls
 */

(function() {
  'use strict';

  // Wait for search cache to be available
  function waitForCache(callback) {
    if (window.searchCache) {
      callback();
    } else {
      setTimeout(function() {
        waitForCache(callback);
      }, 100);
    }
  }

  // Initialize cache integration
  waitForCache(function() {
    console.log('🔌 Integrating search cache with predictive search...');

    // Cache the original fetch function
    const originalFetch = window.fetch;

    // Override fetch to add caching for search requests
    window.fetch = function(url, options) {
      // Check if this is a search request
      const urlStr = typeof url === 'string' ? url : url.toString();
      const isSearchRequest = urlStr.includes('/search/suggest') ||
                             urlStr.includes('predictive_search') ||
                             urlStr.includes('q=') && urlStr.includes('/search');

      if (!isSearchRequest) {
        // Not a search request, proceed normally
        return originalFetch.apply(this, arguments);
      }

      // Extract query from URL
      let searchQuery = '';
      try {
        const parsedUrl = new URL(urlStr, window.location.origin);
        searchQuery = parsedUrl.searchParams.get('q') || '';
      } catch (e) {
        console.warn('Failed to parse search URL:', e);
        return originalFetch.apply(this, arguments);
      }

      const pathname = (typeof url === 'string' ? new URL(urlStr, window.location.origin) : new URL(url)).pathname || '';
      const firstSegment = pathname.split('/').filter(Boolean)[0];
      const localePrefix = firstSegment && firstSegment.length >= 2 && firstSegment.length <= 5 ? firstSegment : '';
      const cacheKey = localePrefix ? localePrefix + '::' + searchQuery : searchQuery;
      const cachedResult = window.searchCache.get(cacheKey);

      if (cachedResult) {
        console.log('💾 Cache HIT for:', searchQuery);

        // Return cached result as a fake Response
        return Promise.resolve(new Response(cachedResult, {
          status: 200,
          statusText: 'OK (Cached)',
          headers: {
            'Content-Type': 'text/html',
            'X-Cache': 'HIT'
          }
        }));
      }

      console.log('🌐 Cache MISS for:', searchQuery, '- Fetching...');

      // No cache hit, proceed with real fetch
      return originalFetch.apply(this, arguments)
        .then(function(response) {
          // Clone the response so we can cache it
          const responseClone = response.clone();

          // Cache the response text
          responseClone.text().then(function(text) {
            if (response.ok && searchQuery.trim()) {
              window.searchCache.set(cacheKey, {}, text);
              console.log('💾 Cached result for:', searchQuery);
            }
          }).catch(function(err) {
            console.warn('Failed to cache response:', err);
          });

          return response;
        });
    };

    console.log('✅ Search cache integration complete');

    // Add cache clear on navigation (optional - keeps cache fresh)
    let lastPath = window.location.pathname;
    setInterval(function() {
      if (window.location.pathname !== lastPath) {
        lastPath = window.location.pathname;
        // Clear cache on page navigation
        window.searchCache.clear();
        console.log('🗑️  Search cache cleared (navigation)');
      }
    }, 1000);
  });

  // Also cache Algolia search if present
  if (window.algoliasearch) {
    console.log('🔍 Algolia detected - integrating cache...');

    waitForCache(function() {
      // Save original algoliasearch
      const originalAlgoliasearch = window.algoliasearch;

      // Wrap algoliasearch
      window.algoliasearch = function(appId, apiKey) {
        const client = originalAlgoliasearch(appId, apiKey);

        // Wrap initIndex
        const originalInitIndex = client.initIndex.bind(client);
        client.initIndex = function(indexName) {
          const index = originalInitIndex(indexName);

          // Wrap search method
          const originalSearch = index.search.bind(index);
          index.search = function(query, options) {
            const cacheKey = query;
            const cachedResult = window.searchCache.get(cacheKey, options || {});

            if (cachedResult) {
              console.log('💾 Algolia cache HIT for:', query);
              return Promise.resolve(cachedResult);
            }

            console.log('🌐 Algolia cache MISS for:', query);

            return originalSearch(query, options).then(function(results) {
              if (query && query.trim()) {
                window.searchCache.set(cacheKey, options || {}, results);
                console.log('💾 Cached Algolia result for:', query);
              }
              return results;
            });
          };

          return index;
        };

        return client;
      };

      console.log('✅ Algolia search cache integration complete');
    });
  }

})();
